import(/* webpackMode: "eager" */ "/home/runner/work/33m2-front/33m2-front/app/error.tsx");
